import {
  NotificationModal,
  NotificationType,
} from "@/components/ui/notification/notification-modal";
import React, { createContext, useState, ReactNode, useContext } from "react";

interface NotificationData {
  type: NotificationType;
  avatar: string;
  title: string;
  name?: string;
  subtitle?: string;
  buttonText: string;
  onButtonClick?: () => void;
  automaticContinue?: boolean;
  automaticContinueDurationMs?: number;
}

interface NotificationContextProps {
  showNotification: (data: NotificationData) => void;
  closeNotification: () => void;
}

const NotificationContext = createContext<NotificationContextProps | undefined>(
  undefined
);

export const NotificationProvider = ({ children }: { children: ReactNode }) => {
  const [notification, setNotification] = useState<NotificationData | null>(
    null
  );

  const showNotification = (data: NotificationData) => {
    setNotification(data);
  };

  const closeNotification = () => {
    setNotification(null);
  };

  return (
    <NotificationContext.Provider
      value={{ showNotification, closeNotification }}
    >
      {children}
      {notification && (
        <NotificationModal
          type={notification.type}
          avatar={notification.avatar}
          name={notification.name}
          title={notification.title}
          subtitle={notification.subtitle}
          buttonText={notification.buttonText}
          automaticAction={notification.automaticContinue}
          automaticActionDurationMs={notification.automaticContinueDurationMs}
          onButtonClick={() => {
            notification.onButtonClick?.();
            closeNotification();
          }}
        />
      )}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error(
      "useNotification must be used within a NotificationProvider"
    );
  }
  return context;
};
